const REGEX = {
  VALID_URL: /^https:\/\/docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9-_]+)\/edit/,
  SPREADSHEET: /\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/,
  SHEET: /\/edit#gid=([0-9]+)/,
  RANGE: /&range=([a-zA-Z]([0-9]?)+:[a-zA-Z]([0-9]?)+)/,
  SHEET_ID: /gid=(\d+)([a-zA-Z0-9&=:]+)?/,
  SHARING: /\?usp=sharing/,
  VALID_CELL: /^[a-zA-Z]([0-9]?)+$/,
  VALID_CELLS: /^[a-zA-Z][0-9]+:[a-zA-Z][0-9]+$|^[a-zA-Z]:[a-zA-Z]$/,
};

const TYPE = 'google-sheets';
const URL_DELETE_ACTION = 'sheets-url-deleted';
const COPY_ID = 'gmail-service-email';

const SHEET_ERRORS = {
  SHEET_NOT_FOUND: 'Requested entity was not found.',
  NO_PERMISSION: 'The caller does not have permission',
  INVALID_RANGE: 'The range is not valid, it should be in the format A1:B2 or A:Z.',
  INVALID_URL: 'Please enter a valid Google Sheet URL',
  INVALID_DATA:
    'We were unable to render your chart. Most likely your sheet has empty values. Please remove empty data points and try again or use the data box instead.',
  READING_ERROR:
    'Something went wrong while reading your sheet. Please specify the range of data you want to import.',
  UNKNOWN_ERROR:
    'An error occurred while fetching the data. Please try again and contact #chartlos channel if the problem persists.',
};

function buildQuery(sheetId, range) {
  const sheetIdQ = sheetId ? `&sheetId=${sheetId}` : '';
  const rangeQ = range ? `&range=${range}` : '';
  return `${sheetIdQ}${rangeQ}`;
}

function getSheetInfo(url) {
  const [spreadsheetIdMatch, sheetIdMatch, rangesMatch] = [
    REGEX.SPREADSHEET,
    REGEX.SHEET,
    REGEX.RANGE,
  ].map((regex) => regex.exec(url));

  const [spreadsheetId, sheetId, ranges] = [
    spreadsheetIdMatch && spreadsheetIdMatch[1],
    sheetIdMatch && sheetIdMatch[1],
    rangesMatch && rangesMatch[1],
  ];

  return [spreadsheetId, sheetId, ranges];
}

function resetDataSettings(activeDoc) {
  let newDoc = activeDoc.setIn(['chart', 'data', 'raw'], '');
  newDoc = newDoc.setIn(['chart', 'data', 'quarterlyResults'], false);
  newDoc = newDoc.setIn(['chart', 'data', 'categories'], null);
  newDoc = newDoc.setIn(['chart', 'data', 'parsed'], null);
  newDoc = newDoc.setIn(['chart', 'data', 'series'], null);
  return newDoc.data;
}

function isInvalidRange(firstCell, lastCell) {
  return (
    firstCell === lastCell ||
    !firstCell ||
    !lastCell ||
    !REGEX.VALID_CELL.test(firstCell) ||
    !REGEX.VALID_CELL.test(lastCell) ||
    !REGEX.VALID_CELLS.test(`${firstCell}:${lastCell}`)
  );
}

function getErrorMessage(error) {
  if (error) {
    if (error === SHEET_ERRORS.NO_PERMISSION) {
      return `${error}. Please give <${window.GOOGLE_SHEETS_EMAIL}> viewer permission to access this sheet.`;
    }
    if (error === SHEET_ERRORS.SHEET_NOT_FOUND) {
      return `${error} Please check the sheet url exists and try again.`;
    }
    return error;
  }
  return SHEET_ERRORS.UNKNOWN_ERROR;
}

function isValidSheetsUrl(sheetsUrl) {
  return sheetsUrl && REGEX.VALID_URL.test(sheetsUrl);
}

export {
  buildQuery,
  getSheetInfo,
  resetDataSettings,
  isInvalidRange,
  getErrorMessage,
  isValidSheetsUrl,
  SHEET_ERRORS,
  TYPE,
  REGEX,
  URL_DELETE_ACTION,
  COPY_ID,
};
